import { BATCH_TEMPLATE_FIELD_GUID } from "./model";
import { RECS_EVENTS_DATA_KEY } from "./selectors";

// Read directly (not via ./events/selectors and ./recs/selectors) so crop-list code can import this without an import cycle.
const EVENTS_STATE_KEY = "EVENTS_STATE";
const RECS_STATE_KEY = "RECS_STATE";

interface IKeyedMap {
    keys: () => Iterable<string>;
}

/** The real fields in the open batch event/rec (template excluded). */
export const getBatchFieldGuids = (state: unknown): string[] => {
    const data = state[RECS_EVENTS_DATA_KEY];
    const eventDetails: IKeyedMap | undefined = data?.[EVENTS_STATE_KEY]?.fieldGuidToEventDetails;
    const recDetails: IKeyedMap | undefined = data?.[RECS_STATE_KEY]?.fieldGuidToRecDetails;
    return [...(eventDetails?.keys() ?? []), ...(recDetails?.keys() ?? [])].filter(
        (guid) => guid !== BATCH_TEMPLATE_FIELD_GUID
    );
};
